import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=1623f6b6"
import script from "./LoginPage.js?vue&type=script&lang=js&external"
export * from "./LoginPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports